import { render, staticRenderFns } from "./balance_change.vue?vue&type=template&id=197cf286&scoped=true&"
import script from "./balance_change.vue?vue&type=script&lang=ts&"
export * from "./balance_change.vue?vue&type=script&lang=ts&"
import style0 from "./balance_change.vue?vue&type=style&index=0&id=197cf286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197cf286",
  null
  
)

export default component.exports